import { render, staticRenderFns } from "./DimensionAutobuyerBox.vue?vue&type=template&id=4ab9243a&scoped=true"
import script from "./DimensionAutobuyerBox.vue?vue&type=script&lang=js"
export * from "./DimensionAutobuyerBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab9243a",
  null
  
)

export default component.exports